export default {
  name: 'introduction-card',
  props: {
    img: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    paragraph: {
      type: Array,
      required: true
    },
    isReverse: {
      type: Boolean,
      default: false
    }
  }
};